import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { KeyUri } from "../key";
import { trackEvent } from "../utils/metaPixel";
const CashfreePaymentStatusTour = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const verifyPayment = async () => {
      try {
        const orderId = searchParams.get("order_id");
        const bookingId = searchParams.get("booking_id");

        if (!orderId) {
          navigate("/", {
            replace: true,
            state: { toastType: "error", toastMessage: "Invalid payment response" },
          });
          return;
        }

        const response = await axios.post(
          `${KeyUri.BACKEND_URI}/tour-booking/cashfree/verify`,
          { orderId, bookingId }
        );

        if (response.data?.success) {
          const booking = response.data.booking;
          const tourBookingId = booking?._id || bookingId;
          const reference = booking?.bookingReference || tourBookingId;

     
          const eventId = sessionStorage.getItem("cashfree_tour_event_id");
          const value = sessionStorage.getItem("cashfree_tour_value") || booking?.amountPaid;
          const tourId = sessionStorage.getItem("cashfree_tour_id") || booking?.tourId;

          trackEvent("Purchase", {
            value: Number(value || 0),
            currency: "INR",
            content_ids: [tourId],
            content_type: "tour_package",
            content_name: "Tour Booking",
          }, eventId || booking?.eventId);

          sessionStorage.removeItem("cashfree_tour_event_id");
          sessionStorage.removeItem("cashfree_tour_value");
          sessionStorage.removeItem("cashfree_tour_id");

          alert(
            booking?.paymentType === "advance"
              ? `Advance payment successful! Your booking reference is ${reference}. Remaining amount: ₹${(booking.remainingAmount || 0).toLocaleString("en-IN")}`
              : `Booking confirmed successfully! Your booking reference is ${reference}`
          );
          navigate(`/tour-invoice?bookingId=${tourBookingId}`);
        } else {
          alert(response.data?.message || "Payment failed or was not completed.");
          navigate("/");
        }
      } catch (error) {
        console.error(error);
        alert(error?.response?.data?.message || "Payment verification failed.");
        navigate("/");
      }
    };

    verifyPayment();
  }, []);

  return null;
};

export default CashfreePaymentStatusTour;